import { useEffect, useState, useContext } from "react";
import axios from "axios";
import { AuthContext } from "../../context/AuthContext";
import { ToastContainer, toast } from "react-toastify";
import 'react-toastify/dist/ReactToastify.css';
import { Button } from "antd";
import { Form, Input, Typography, Card, Select } from "antd";

const { Option } = Select;

export default function CreateMrf({ onSubmitSuccess }) {
    const [departments, setDepartments] = useState([]);
    const [designations, setDesignations] = useState([]);
    const [allDesignations, setAllDesignations] = useState([]);
    const [organizations, setOrganizations] = useState([]);
    const [showAddDesig, setShowAddDesig] = useState(false);
    const [showmessage, setShowmessage] = useState(false);
    const [employees, setEmployees] = useState({
        name: '',
        designation: ''
    });
    const isMobile = window.innerWidth < 768;
    const [loading, setLoading] = useState(false);

    const [workLocation, setWorkLocation] = useState([]);

    const { authData, backUrl } = useContext(AuthContext);
    const req_type = ['New', "Replacement"];
    const location = ['Site Office', 'Head Office'];

    const message = "MRF submitted successfully!";
    const firstName = authData?.employee?.first_name || "Unknown";
    const designation = authData?.employee?.designation || "N/A";
    const r_to = authData.employee.reporting_to;
    const [errors, setErrors] = useState({});

    const [mrfdata, setMrfdata] = useState({
        organisation: '',
        department: null,
        site_location: '',
        required_by: '',
        designation: null,
        no_of_vacancies: '',
        requisition_type: '',
        reporting_to: r_to,
        place_of_work: [],
        job_description: '',
        qualification: '',
        experience: '',
        skill_sets: '',
        other_requirements: '',
        justification: "",
        name_of_leaving_employee: '',
        reason_for_leaving: '',
        date_of_leaving: '',
        present_dept_strength: 0,
        strength_of_function: '',
        replacement_remarks: '',
        mrf_salary_from: 0,
        mrf_salary_to: 0,
        status: "Submitted",
        job_description_attachment: null  // This will hold the File object
    });

    const [addDesig, setAddDesig] = useState({
        name: '',
        department: '',
        grade: '',
        level: ''
    });

    const getDesignationTitle = (id) => allDesignations.find((d) => d.id === id)?.name || "N/A";

    const validateForm = () => {
        const requiredFields = [
            'organisation', 'department', 'site_location', 'required_by', 'designation',
            'no_of_vacancies', 'requisition_type', 'place_of_work',
            'job_description', 'qualification', 'experience', 'skill_sets',
            'other_requirements', 'justification'
        ];

        const newErrors = {};

        requiredFields.forEach(field => {
            if (!mrfdata[field] || (Array.isArray(mrfdata[field]) && mrfdata[field].length === 0)) {
                newErrors[field] = "This field is required.";
            }
        });

        if (mrfdata.requisition_type === 'Replacement') {
            ['name_of_leaving_employee', 'date_of_leaving', 'reason_for_leaving', 'present_dept_strength', 'strength_of_function', 'replacement_remarks'].forEach(field => {
                if (!mrfdata[field]) {
                    newErrors[field] = "This field is required.";
                }
            });
        }

        setErrors(newErrors);
        return Object.keys(newErrors).length === 0;
    };

    const fetchDepartments = async (v) => {
        try {
            const res = await axios.get(`${backUrl}/api/emp/departments/?organisation=${v}`);
            setDepartments(res.data.results);
        } catch (err) {
            console.error("Failed to fetch departments:", err);
        }
    };

    const fetchOrganizations = async () => {
        try {
            const res = await axios.get(`${backUrl}/api/emp/organisations/`);
            setOrganizations(res.data.results);
        } catch (err) {
            console.error("Failed to fetch organizations:", err);
        }
    };

    const fetchDesignations = async (did) => {
        try {
            const res = await axios.get(`${backUrl}/api/emp/designations/?department=${did}`);
            setDesignations(res.data.results);
        } catch (err) {
            console.error("Error fetching designations", err);
        }
    };

    const fetchAllDesignations = async () => {
        try {
            const res = await axios.get(`${backUrl}/api/emp/designations/`);
            setAllDesignations(res.data.results);
        } catch (err) {
            console.error("Error fetching designations", err);
        }
    };

    const fetchWorkLocation = async () => {
        try {
            const res = await axios.get(`${backUrl}/api/emp/worklocation/`);
            setWorkLocation(res.data.results);
        } catch (err) {
            console.error("Error fetching work locations", err);
        }
    }

    const fetchEmployees = async (eid) => {
        try {
            const res = await axios.get(`${backUrl}/api/emp/employees/${eid}/`, {
                headers: { Authorization: `Bearer ${authData?.access}` }
            });
            setEmployees({
                name: res.data.first_name,
                designation: res.data.designation,
            });
        } catch (err) {
            console.error("Error fetching employee:", err);
        }
    };

    useEffect(() => {
        fetchOrganizations();
        fetchEmployees(r_to);
        fetchAllDesignations();
        fetchWorkLocation();
    }, [r_to]);

    const handleChange = (e) => {
        const { name, value, type, checked } = e.target;
        const parsedValue = type === "checkbox" ? checked : value;

        setMrfdata(prev => ({
            ...prev,
            [name]: parsedValue
        }));
    };

    // Fixed: Correct file handling
    const handleFileChange = (e) => {
        const file = e.target.files[0];
        if (file) {
            setMrfdata(prev => ({
                ...prev,
                job_description_attachment: file
            }));
        }
    };

    const handleSubmit = async (e) => {
        e.preventDefault();

        if (!validateForm()) {
            toast.error("Please fill all required fields.");
            return;
        }

        if (!authData || !authData.access) {
            alert("Access token is missing! Please log in again.");
            return;
        }

        const formData = new FormData();

        // Append all text/number fields
        Object.keys(mrfdata).forEach((key) => {
            if (mrfdata[key] !== null && mrfdata[key] !== undefined && mrfdata[key] !== '') {
                if (key === "place_of_work") {
                    mrfdata[key].forEach((loc) => formData.append("place_of_work", loc));
                } else if (key !== "job_description_attachment") {
                    formData.append(key, mrfdata[key]);
                }
            }
        });

        // Special handling for file
        if (mrfdata.job_description_attachment) {
            formData.append("job_description_attachment", mrfdata.job_description_attachment);
        }

        // Format date_of_leaving if exists
        if (mrfdata.date_of_leaving) {
            const dateObj = new Date(mrfdata.date_of_leaving);
            const day = String(dateObj.getDate()).padStart(2, "0");
            const month = String(dateObj.getMonth() + 1).padStart(2, "0");
            const year = dateObj.getFullYear();
            formData.set("date_of_leaving", `${day}-${month}-${year}`);
        }

        try {
            setLoading(true);
            await axios.post(
                `${backUrl}/api/emp/manpowerrequisitions/`,
                formData,
                {
                    headers: {
                        Authorization: `Bearer ${authData.access}`,
                        "Content-Type": "multipart/form-data",
                    },
                }
            );

            // Reset form including file input
            setMrfdata({
                organisation: '',
                department: null,
                site_location: '',
                required_by: '',
                designation: null,
                no_of_vacancies: '',
                requisition_type: '',
                reporting_to: r_to,
                place_of_work: [],
                job_description: '',
                qualification: '',
                experience: '',
                skill_sets: '',
                other_requirements: '',
                justification: "",
                name_of_leaving_employee: '',
                reason_for_leaving: '',
                date_of_leaving: '',
                present_dept_strength: 0,
                strength_of_function: '',
                replacement_remarks: '',
                mrf_salary_from: 0,
                mrf_salary_to: 0,
                status: "Submitted",
                job_description_attachment: null
            });

            setErrors({});
            toast.success("MRF submitted successfully!");
            onSubmitSuccess();

        } catch (error) {
            const errorMessage =
                error.response?.data?.data ||
                error.response?.data?.message ||
                "Failed to submit MRF";

            toast.error(errorMessage);
        }
        finally {
            setLoading(false)
        }
    };

    const handleAddDesig = () => {
        setShowAddDesig(true);
    };

    const addnewdesignation = async () => {
        try {
            await axios.post(`${backUrl}/api/emp/designations/`, addDesig);
            setAddDesig({ name: '', department: '', grade: '', level: '' });
            setShowAddDesig(false);

            if (addDesig.department) {
                await fetchDesignations(addDesig.department);
            }
            toast.success("Designation added successfully!");
        } catch (err) {
            console.error("Failed to add designation:", err);
            toast.error("Failed to add designation");
        }
    };

    // ... rest of your render functions remain unchanged ...

    const renderDeploymentSection = (isHod) => (
        <div className="form-2">
            <div className="deployment-area">
                <h3>Deployment</h3>
                <label htmlFor="place">Place Of Work</label>
                <Select
                    mode="multiple"
                    placeholder="Select place(s) of work"
                    value={mrfdata.place_of_work}
                    onChange={(values) =>
                        setMrfdata((prev) => ({
                            ...prev,
                            place_of_work: values,
                        }))
                    }
                    style={{ width: "100%" }}
                >
                    {workLocation.map((loc) => (
                        <Option key={loc.id} value={loc.id}>
                            {loc.name}
                        </Option>
                    ))}
                </Select>
                {errors.place_of_work && <p style={{ color: 'red', fontSize: '12px' }}>{errors.place_of_work}</p>}

                <label htmlFor="jd">Job Description </label>
                <textarea
                    name="job_description"
                    value={mrfdata.job_description || ""}
                    id="jd"
                    onChange={handleChange}
                    placeholder="Job Description"
                />
                {errors.job_description && <p style={{ color: 'red', fontSize: '12px' }}>{errors.job_description}</p>}

                <label htmlFor="jd-upload">Job Description Upload (PDF/DOC)</label>
                <input
                    type="file"
                    accept=".pdf,.doc,.docx"
                    onChange={handleFileChange}
                />
                {mrfdata.job_description_attachment && (
                    <p style={{ color: 'green', fontSize: '12px' }}>
                        Selected: {mrfdata.job_description_attachment.name}
                    </p>
                )}

                <hr />

                {isHod && (
                    <>
                        <h5>Salary Range</h5>
                        <label htmlFor="from">From </label>
                        <input
                            type="number"
                            name="mrf_salary_from"
                            value={mrfdata.mrf_salary_from || ""}
                            id="from"
                            onChange={handleChange}
                            placeholder="from"
                        />

                        <label htmlFor="to">To </label>
                        <input
                            type="number"
                            name="mrf_salary_to"
                            value={mrfdata.mrf_salary_to || ""}
                            id="to"
                            onChange={handleChange}
                            placeholder="to"
                        />
                    </>
                )}
            </div>

            {/* Requirement Profile section remains unchanged */}
            <div className="requirement-profile">
                <h3>Requirement Profile</h3>
                <label htmlFor="qualification">Qualification </label>
                <input
                    type="text"
                    name="qualification"
                    value={mrfdata.qualification || ""}
                    id="qualification"
                    onChange={handleChange}
                    placeholder="Qualification"
                />
                {errors.qualification && <p style={{ color: 'red', fontSize: '12px' }}>{errors.qualification}</p>}

                <label htmlFor="experience">Experience </label>
                <input
                    type="text"
                    name="experience"
                    value={mrfdata.experience || ""}
                    id="experience"
                    onChange={handleChange}
                    placeholder="Experience - e.g. 1/10 for 1 year 10 months"
                />
                {errors.experience && <p style={{ color: 'red', fontSize: '12px' }}>{errors.experience}</p>}

                <label htmlFor="skillset">Skill Sets </label>
                <textarea
                    name="skill_sets"
                    value={mrfdata.skill_sets || ""}
                    id="skillset"
                    onChange={handleChange}
                    placeholder="Skill Sets"
                />
                {errors.skill_sets && <p style={{ color: 'red', fontSize: '12px' }}>{errors.skill_sets}</p>}

                <label htmlFor="others">Any Other Requirements </label>
                <textarea
                    name="other_requirements"
                    value={mrfdata.other_requirements || ""}
                    id="others"
                    onChange={handleChange}
                    placeholder="Any other Requirements"
                />
                {errors.other_requirements && <p style={{ color: 'red', fontSize: '12px' }}>{errors.other_requirements}</p>}

                <label htmlFor="justification">Justification </label>
                <textarea
                    name="justification"
                    value={mrfdata.justification || ""}
                    id="justification"
                    onChange={handleChange}
                    placeholder="Justification"
                />
                {errors.justification && <p style={{ color: 'red', fontSize: '12px' }}>{errors.justification}</p>}
            </div>
        </div>
    );

    const renderFormSection = () => (
        <div className="form container">
            <div>
                <label htmlFor="organisations">Organization </label>
                <select className="fixed-size" name="organisation" id="organisations" onChange={(e) => {
                    handleChange(e);
                    fetchDepartments(e.target.value);
                    // setAddDesig({ ...addDesig, department: e.target.value });
                }}>
                    <option value="">-- Select --</option>
                    {organizations.map((org) => (
                        <option key={org.id} value={org.id}>{org.name}</option>
                    ))}
                </select>
                {errors.organisation && <p style={{ color: 'red', fontSize: '12px' }}>{errors.organisation}</p>}

            </div>

            <div>
                <label htmlFor="departments">Department </label>
                <select
                    className="fixed-size"
                    name="department"
                    id="departments"
                    onChange={(e) => {
                        handleChange(e);
                        fetchDesignations(e.target.value);
                        setAddDesig({ ...addDesig, department: e.target.value });
                    }}
                >
                    <option value="">-- Select --</option>
                    {departments.map((dept) => (
                        <option key={dept.id} value={dept.id}>{dept.name}</option>
                    ))}
                </select>
                {errors.department && <p style={{ color: 'red', fontSize: '12px' }}>{errors.department}</p>}
            </div>

            <div>
                <label htmlFor="designation">Designation </label>
                <select
                    className="fixed-size"
                    name="designation"
                    id="designation"
                    onChange={(e) => {
                        if (e.target.value === "add-new") {
                            handleAddDesig();
                        } else {
                            handleChange(e);
                        }
                    }}
                    value={mrfdata.designation || ""}
                >
                    <option value="">-- Select --</option>
                    {designations.map((des, idx) => (
                        <option key={idx} value={des.id}>{des.name}</option>
                    ))}
                    <option value="add-new">➕ Add New Designation</option>
                </select>
                {errors.designation && <p style={{ color: 'red', fontSize: '12px' }}>{errors.designation}</p>}
            </div>

            <div>
                <label htmlFor="site_location">Site/Location </label>
                <select className="fixed-size" name="site_location" id="site_location" onChange={handleChange}>
                    <option value="">-- Select --</option>
                    {location.map((loc) => (
                        <option key={loc} value={loc}>{loc}</option>
                    ))}
                </select>
                {errors.site_location && <p style={{ color: 'red', fontSize: '12px' }}>{errors.site_location}</p>}
            </div>

            {
                isMobile ? (
                    <div>
                        <center><label htmlFor="requiredby">Required By </label></center>
                        <input
                            className="fixed-size"
                            type="text"
                            name="required_by"
                            value={mrfdata.required_by || ""}
                            id="requiredby"
                            style={{ width: '100%' }}
                            onChange={handleChange}
                            placeholder="Specify in Months or weeks"
                        />
                        {errors.department && <p style={{ color: 'red', fontSize: '12px' }}>{errors.department}</p>}


                    </div>
                ) : (
                    <div>
                        <label htmlFor="requiredby">Required By </label>
                        <input
                            className="fixed-size"
                            type="text"
                            name="required_by"
                            value={mrfdata.required_by || ""}
                            id="requiredby"
                            onChange={handleChange}
                            placeholder="Specify in Months or weeks"
                        />
                        {errors.department && <p style={{ color: 'red', fontSize: '12px' }}>{errors.department}</p>}


                    </div>
                )
            }


            {
                isMobile ? (
                    <div>
                        <center><label htmlFor="vacancies">No. of Vacancies </label></center>
                        <input
                            className="fixed-size"
                            type="text"
                            style={{ width: '100%' }}
                            name="no_of_vacancies"
                            value={mrfdata.no_of_vacancies || ""}
                            id="vacancies"
                            onChange={handleChange}
                            placeholder="Number of Vacancies"
                        />
                        {errors.no_of_vacancies && <p style={{ color: 'red', fontSize: '12px' }}>{errors.no_of_vacancies}</p>}
                    </div>
                ) : (
                    <div>
                        <label htmlFor="vacancies">No. of Vacancies </label>
                        <input
                            className="fixed-size"
                            type="text"
                            name="no_of_vacancies"
                            value={mrfdata.no_of_vacancies || ""}
                            id="vacancies"
                            onChange={handleChange}
                            placeholder="Number of Vacancies"
                        />
                        {errors.no_of_vacancies && <p style={{ color: 'red', fontSize: '12px' }}>{errors.no_of_vacancies}</p>}
                    </div>
                )
            }



            <div>
                <label></label>
            </div>
        </div>
    );



    const renderReplacementSection = () => (
        mrfdata.requisition_type === 'Replacement' && (
            <>
                <h3>If Replacement</h3>
                <div className="replacement-form">
                    <div className="form-group">
                        <label htmlFor="leavingemployee">Name of the Leaving Employee </label>
                        <input
                            type="text"
                            id="leavingemployee"
                            name="name_of_leaving_employee"
                            value={mrfdata.name_of_leaving_employee || ""}
                            onChange={handleChange}
                            placeholder="Name of the leaving employee"
                        />
                        {errors.name_of_leaving_employee && <p style={{ color: 'red', fontSize: '12px' }}>{errors.name_of_leaving_employee}</p>}

                        <label htmlFor="leavingdate">Date of Leaving </label>
                        <input
                            type="date"
                            id="leavingdate"
                            name="date_of_leaving"
                            value={mrfdata.date_of_leaving || ""}
                            onChange={handleChange}
                        />
                        {errors.date_of_leaving && <p style={{ color: 'red', fontSize: '12px' }}>{errors.date_of_leaving}</p>}

                        <label htmlFor="reason">Reason for Leaving </label>
                        <textarea
                            id="reason"
                            name="reason_for_leaving"
                            placeholder="Reason for Leaving"
                            value={mrfdata.reason_for_leaving || ""}
                            onChange={handleChange}
                        />
                        {errors.reason_for_leaving && <p style={{ color: 'red', fontSize: '12px' }}>{errors.reason_for_leaving}</p>}
                    </div>

                    <div className="form-group">
                        <label htmlFor="strength">Present Strength in the Category </label>
                        <input
                            type="text"
                            id="strength"
                            name="present_dept_strength"
                            placeholder="Present Strength in the Category"
                            onChange={handleChange}
                            value={mrfdata.present_dept_strength || ""}
                        />
                        {errors.present_dept_strength && <p style={{ color: 'red', fontSize: '12px' }}>{errors.present_dept_strength}</p>}

                        <label htmlFor="strengthfunction">Strength of the Function </label>
                        <input
                            type="text"
                            id="strengthfunction"
                            name="strength_of_function"
                            placeholder="Strength of the Function"
                            onChange={handleChange}
                            value={mrfdata.strength_of_function || ""}
                        />
                        {errors.strength_of_function && <p style={{ color: 'red', fontSize: '12px' }}>{errors.strength_of_function}</p>}

                        <label htmlFor="remarks">Remarks </label>
                        <textarea
                            id="remarks"
                            name="replacement_remarks"
                            placeholder="Remarks"
                            value={mrfdata.replacement_remarks || ""}
                            onChange={handleChange}
                        />
                        {errors.replacement_remarks && <p style={{ color: 'red', fontSize: '12px' }}>{errors.replacement_remarks}</p>}
                    </div>
                </div>
            </>
        )
    );

    const inputStyle = { width: '300px' };

    return (
        <>
            <ToastContainer position="top-center" autoClose={3000} />

            {/* Add Designation Modal remains unchanged */}
            {showAddDesig && (
                <div style={{
                    position: "fixed", top: 0, left: 0, width: "100%", height: "100%",
                    backgroundColor: "rgba(0, 0, 0, 0.67)", display: "flex",
                    justifyContent: "center", alignItems: "center", zIndex: 1000
                }}>
                    <Card className="add-desig-form" bordered={false} style={{ maxWidth: 400, width: "90%" }}>
                        <div style={{ marginBottom: "1rem" }}>
                            <a className="bread-anchor" onClick={() => setShowAddDesig(false)}>Back</a>
                        </div>
                        <Form layout="vertical" onFinish={addnewdesignation}>
                            <Form.Item label="Designation" rules={[{ required: true }]}>
                                <Input
                                    placeholder="Designation Name"
                                    value={addDesig.name}
                                    onChange={(e) => setAddDesig({ ...addDesig, name: e.target.value })}
                                />
                            </Form.Item>
                            <Form.Item>
                                <Button style={{ backgroundColor: '#125ea7', color: 'white' }} htmlType="submit" block>
                                    Add Designation
                                </Button>
                            </Form.Item>
                        </Form>
                    </Card>
                </div>
            )}

            <center><h5>Manpower Requisition Form (MRF)</h5></center>

            {renderFormSection()}

            <center>
                <div id="requisition-type">
                    <label htmlFor="type">Requisition Type </label>
                    <select className="fixed-size" name="requisition_type" onChange={handleChange}>
                        <option value="">-- Select --</option>
                        {req_type.map((req) => (
                            <option key={req} value={req}>{req}</option>
                        ))}
                    </select>
                    {errors.requisition_type && <p style={{ color: 'red', fontSize: '12px' }}>{errors.requisition_type}</p>}
                </div>
            </center>

            <hr />

            {renderDeploymentSection(authData.employee.is_hod === true)}
            {renderReplacementSection()}

            <center>
                <Button style={{ backgroundColor: '#125ea7', color: 'white' }}
                    onClick={handleSubmit}
                    loading={loading}
                    disabled={loading}>
                    Submit MRF
                </Button>
            </center>

            {showmessage && <p className="success-message">{message}</p>}
        </>
    );
}